import { EUserCardActionTypes } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setUserCardOpened = actionGenerator<EUserCardActionTypes.Open, void>(EUserCardActionTypes.Open);

export const setUserCardClosed = actionGenerator<EUserCardActionTypes.Close, void>(EUserCardActionTypes.Close);
